module.exports = __webpack_public_path__ + "images/subscribe-banner-pattern.svg";